// libs
import { styled } from '@nykaa/ui-components';

// constants
import { DWEB_MAX_WIDTH, BASE_GUTTER_SPACE } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;
  max-width: ${DWEB_MAX_WIDTH}px;
  display: flex;
  flex-wrap: wrap;
  margin: ${BASE_GUTTER_SPACE}px auto 0;
`;

export const WidgetsContainer = styled.div<{
  backgroundColor: string;
  textColor: string;
  marginTop?: number;
}>`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  justify-items: stretch;
  color: ${(props) => props.textColor};
  margin: auto;

  ${({ backgroundColor }) =>
    `${
      backgroundColor !== '#fff' &&
      `
        background-color: ${backgroundColor};
    `
    }`}

  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`}
`;
